// src/utils/mockElectron.js
const MOCK_CONNECTIONS = [
  {
    id: '1234-172.217.14.14-443', pid: 1234, appName: 'Google Chrome',
    remoteIP: '172.217.14.14', remotePort: 443, protocol: 'IPv4',
    isEncrypted: true, country: 'United States', countryCode: 'US',
    domain: 'google.com', service: 'Google', serviceLabel: 'Secure Web',
    summary: 'Google Chrome securely connected to google.com',
    connectedAt: Date.now() - 252000, durationMs: 252000, riskLevel: 'normal',
    threatScore: 0, threatLevel: 'clean', totalReports: 0, isp: 'Google LLC',
  },
  {
    id: '1234-17.253.144.10-443', pid: 1234, appName: 'Google Chrome',
    remoteIP: '17.253.144.10', remotePort: 443, protocol: 'IPv4',
    isEncrypted: true, country: 'United States', countryCode: 'US',
    domain: 'apple.com', service: 'Apple', serviceLabel: 'Secure Web',
    summary: 'Google Chrome securely connected to apple.com',
    connectedAt: Date.now() - 45000, durationMs: 45000, riskLevel: 'normal',
  },
  {
    id: '5678-104.244.42.129-443', pid: 5678, appName: 'Slack',
    remoteIP: '104.244.42.129', remotePort: 443, protocol: 'IPv4',
    isEncrypted: true, country: 'United States', countryCode: 'US',
    domain: 'slack.com', service: 'Slack', serviceLabel: 'Secure Web',
    summary: 'Slack securely connected to slack.com',
    connectedAt: Date.now() - 3720000, durationMs: 3720000, riskLevel: 'normal',
  },
  {
    id: '9012-13.32.240.55-443', pid: 9012, appName: 'Dropbox',
    remoteIP: '13.32.240.55', remotePort: 443, protocol: 'IPv4',
    isEncrypted: true, country: 'United States', countryCode: 'US',
    domain: 'dropbox.com', service: 'Dropbox', serviceLabel: 'Secure Web',
    summary: 'Dropbox securely connected to dropbox.com',
    connectedAt: Date.now() - 300000, durationMs: 300000, riskLevel: 'normal',
  },
  {
    id: '3456-93.184.216.34-80', pid: 3456, appName: 'Safari',
    remoteIP: '93.184.216.34', remotePort: 80, protocol: 'IPv4',
    isEncrypted: false, country: 'United States', countryCode: 'US',
    domain: 'example.com', service: null, serviceLabel: 'Web (HTTP)',
    summary: 'Safari connected to example.com',
    connectedAt: Date.now() - 30000, durationMs: 30000, riskLevel: 'warning',
  },
  {
    id: '7890-151.101.1.69-443', pid: 7890, appName: 'Spotify',
    remoteIP: '151.101.1.69', remotePort: 443, protocol: 'IPv4',
    isEncrypted: true, country: 'Sweden', countryCode: 'SE',
    domain: 'spotify.com', service: 'Spotify', serviceLabel: 'Secure Web',
    summary: 'Spotify securely connected to spotify.com',
    connectedAt: Date.now() - 900000, durationMs: 900000, riskLevel: 'normal',
  },
  {
    id: '2345-52.86.77.1-443', pid: 2345, appName: 'Zoom',
    remoteIP: '52.86.77.1', remotePort: 443, protocol: 'IPv4',
    isEncrypted: true, country: 'United States', countryCode: 'US',
    domain: 'zoom.us', service: 'Zoom', serviceLabel: 'Secure Web',
    summary: 'Zoom securely connected to zoom.us',
    connectedAt: Date.now() - 1800000, durationMs: 1800000, riskLevel: 'normal',
  },
  {
    id: '6789-194.68.252.93-4444', pid: 6789, appName: 'Unknown Process',
    remoteIP: '194.68.252.93', remotePort: 4444, protocol: 'IPv4',
    isEncrypted: false, country: 'Iran', countryCode: 'IR',
    domain: null, service: null, serviceLabel: 'Port 4444',
    summary: 'Unknown Process connected to a server in Iran',
    connectedAt: Date.now() - 5000, durationMs: 5000, riskLevel: 'critical',
    threatScore: 87, threatLevel: 'high', totalReports: 243, isp: 'Tehran-meida.ir',
  },
]

const MOCK_METRICS = {
  memory: { totalBytes: 16e9, usedBytes: 10.2e9, percentUsed: 64, totalGB: '16.0', usedGB: '10.2' },
  cpu: { percentUsed: 23, loadAvg1m: '1.87', coreCount: 10, model: 'Apple M2 Pro' },
  timestamp: Date.now(),
}

const MOCK_ALERTS = [
  {
    id: 'alert-1', ruleId: 'unencrypted_connection', severity: 'warning',
    icon: '🔓', appName: 'Safari', pid: 3456,
    message: 'Safari is sending data without encryption. Your activity on this connection is visible on the network.',
    remoteIP: '93.184.216.34', remotePort: 80, protocol: 'IPv4',
    country: 'United States', countryCode: 'US', domain: 'example.com',
    isEncrypted: false,
    timestamp: Date.now() - 15000, dismissed: false,
  },
  {
    id: 'alert-2', ruleId: 'unusual_low_port', severity: 'critical',
    icon: '🚨', appName: 'Unknown Process', pid: 6789,
    message: 'Unknown Process is using an unusual port (4444) and connecting to Iran. This is uncommon and worth investigating immediately.',
    remoteIP: '194.68.252.93', remotePort: 4444, protocol: 'IPv4',
    country: 'Iran', countryCode: 'IR', domain: null,
    isEncrypted: false,
    timestamp: Date.now() - 5000, dismissed: false,
  },
]

const MOCK_AI = {
  '1234-172.217.14.14-443': 'This is a completely normal connection. Google Chrome is communicating securely with Google\'s servers on port 443 (HTTPS). All data is encrypted and this is standard browsing activity — nothing to worry about.',
  '1234-17.253.144.10-443': 'Chrome is connected to Apple\'s servers, likely for iCloud features or Apple Wallet sync built into the browser. This is a secure connection from Apple\'s official IP range (17.x.x.x). No cause for concern.',
  '5678-104.244.42.129-443': 'Slack maintains a persistent encrypted connection to deliver messages in real time. This has been active for over an hour, which is completely normal for a running messaging app.',
  '9012-13.32.240.55-443': 'Dropbox is syncing files to Amazon AWS infrastructure — standard practice since Dropbox uses AWS S3 for storage. The connection is encrypted and within Amazon\'s official IP range.',
  '3456-93.184.216.34-80': 'This connection is unencrypted (HTTP port 80), meaning data is sent in plain text. Anyone on your network could read this traffic. Consider whether this site should be visited over HTTPS, or use Block IP to stop this connection.',
  '7890-151.101.1.69-443': 'Spotify is connected to its CDN to stream audio. Port 443 with encryption is exactly expected — the stream is encrypted so no one can see what you\'re listening to. Sweden is Spotify\'s home country, so this location is normal.',
  '2345-52.86.77.1-443': 'Zoom maintains a connection to Amazon AWS for video conferencing. This has been open for 30 minutes, consistent with an ongoing or recently ended meeting. Fully encrypted.',
  '6789-194.68.252.93-4444': 'This connection is suspicious. Port 4444 is commonly associated with remote access tools and malware. An unknown process is connecting unencrypted to Iran. Unless you installed software that uses this port, investigate immediately. Use Kill Process or Block IP to stop it.',
}

let _speedListeners = [], _connListeners = [], _metricsListeners = [], _alertListeners = []
let _interval = null

function startPolling() {
  if (_interval) return
  _interval = setInterval(() => {
    const down = 2.5e6 * (0.8 + Math.random() * 1.2)  // 2-5 MB/s typical download
    const up   = 150e3  * (0.5 + Math.random() * 1.5)  // 75-375 KB/s typical upload
    _speedListeners.forEach(cb => cb({
      downloadBps: down, uploadBps: up,
      downloadHuman: fmt(down), uploadHuman: fmt(up),
      history: [], timestamp: Date.now(),
    }))
    _connListeners.forEach(cb => cb(
      MOCK_CONNECTIONS.map(c => ({ ...c, durationMs: Date.now() - c.connectedAt }))
    ))
    _metricsListeners.forEach(cb => cb({
      ...MOCK_METRICS,
      cpu: { ...MOCK_METRICS.cpu, percentUsed: 20 + Math.round(Math.random() * 15) },
      timestamp: Date.now(),
    }))
  }, 2000)
}

function fmt(bps) {
  if (bps < 1024) return `${Math.round(bps)} B/s`
  if (bps < 1048576) return `${(bps / 1024).toFixed(1)} KB/s`
  return `${(bps / 1048576).toFixed(2)} MB/s`
}

export const mockElectronAPI = {
  isElectron: false, platform: 'darwin',
  getConnections:   async () => MOCK_CONNECTIONS.map(c => ({ ...c, durationMs: Date.now() - c.connectedAt })),
  getSystemMetrics: async () => MOCK_METRICS,
  getAlertHistory:  async () => MOCK_ALERTS,
  dismissAlert:     async () => true,
  onSpeedUpdate:       (cb) => { _speedListeners.push(cb); startPolling(); return () => { _speedListeners = _speedListeners.filter(l=>l!==cb) } },
  onConnectionsUpdate: (cb) => { _connListeners.push(cb);                  return () => { _connListeners   = _connListeners.filter(l=>l!==cb) } },
  onMetricsUpdate:     (cb) => { _metricsListeners.push(cb);               return () => { _metricsListeners= _metricsListeners.filter(l=>l!==cb) } },
  onNewAlert:          (cb) => { _alertListeners.push(cb); setTimeout(() => _alertListeners.forEach(l=>l(MOCK_ALERTS[1])), 4000); return () => { _alertListeners = _alertListeners.filter(l=>l!==cb) } },
  explainConnection: async (conn) => {
    await new Promise(r => setTimeout(r, 1400 + Math.random() * 600))
    return { ok: true, text: MOCK_AI[conn.id] || `${conn.appName} is making a ${conn.isEncrypted?'secure':'plain'} connection to ${conn.domain||conn.remoteIP} in ${conn.country||'an unknown location'} on port ${conn.remotePort}.` }
  },
  killConnection: async ({ pid, appName }) => {
    await new Promise(r => setTimeout(r, 700))
    // Remove all connections from this process
    const idx = MOCK_CONNECTIONS.findIndex(c => c.pid === pid)
    if (idx !== -1) MOCK_CONNECTIONS.splice(idx, 1)
    return { ok: true, message: `${appName} (PID ${pid}) was terminated successfully.` }
  },
  blockIP: async ({ remoteIP, appName }) => {
    await new Promise(r => setTimeout(r, 900))
    // Remove all connections to this IP
    const idx = MOCK_CONNECTIONS.findIndex(c => c.remoteIP === remoteIP)
    if (idx !== -1) MOCK_CONNECTIONS.splice(idx, 1)
    return { ok: true, message: `Traffic to ${remoteIP} (${appName}) is now blocked.` }
  },
  trayGetSnapshot:   async () => null,
  trayOpenDashboard: () => {},
}
